export const fundmetricConstants = {
  FUNDMETRIC_CREATE_LOADING: 'FUNDMETRIC_CREATE_LOADING',
  FUNDMETRIC_CREATE_SUCCESS: 'FUNDMETRIC_CREATE_SUCCESS',
  FUNDMETRIC_CREATE_FAILURE: 'FUNDMETRIC_CREATE_FAILURE',
  FUNDMETRIC_ERROR_RELOAD: 'FUNDMETRIC_ERROR_RELOAD',

  FUNDMETRIC_LIST_LOADING: 'FUNDMETRIC_LIST_LOADING',
  FUNDMETRIC_LIST_SUCCESS: 'FUNDMETRIC_LIST_SUCCESS',
  FUNDMETRIC_LIST_FAILURE: 'FUNDMETRIC_LIST_FAILURE',

  FUNDMETRIC_EDIT_LOADING: 'FUNDMETRIC_EDIT_LOADING',
  FUNDMETRIC_EDIT_SUCCESS: 'FUNDMETRIC_EDIT_SUCCESS',
  FUNDMETRIC_EDIT_FAILURE: 'FUNDMETRIC_EDIT_FAILURE',

  FUNDMETRIC_DELETE_LOADING: 'FUNDMETRIC_DELETE_LOADING',
  FUNDMETRIC_DELETE_SUCCESS: 'FUNDMETRIC_DELETE_SUCCESS',
  FUNDMETRIC_DELETE_FAILURE: 'FUNDMETRIC_DELETE_FAILURE'
};
